import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/core/helpers/api-urls';
import { AbstractLoutyEntiteService } from 'src/app/core/services/abstract-louty-entite.service';
import { ActiviteMembresDto } from '../models/association-membre-activite-dto';

@Injectable({
  providedIn: 'root',
})
export class AssociationActiviteMembresService extends AbstractLoutyEntiteService<ActiviteMembresDto, any> {
  protected getUrl = ApiUrls.getActiviteMembresUrl();
  protected duplicateUrl: string;
  protected getListUrl: string;
  protected saveUrl = ApiUrls.saveActiviteMembresUrl();
  protected saveListUrl: string;
  protected deleteUrl: string;
  protected deleteListUrl: string;
  protected getPaginatedListUrl: string;
  protected getIdNumeroDicoUrl: string;
  protected exportListToFileUrl: string;
  protected exportFileName: string;

  constructor(
    protected http: HttpClient,
    @Inject('API_BASE_URL') baseUrl: string,
  ) {
    super();
    this._apiBaseUrl = baseUrl;
  }
}
